import Service, { service } from '@ember/service';
import { task } from 'ember-concurrency';
import { queryManager } from 'ember-apollo-client';

import packageByIdQuery from 'my-phorest/gql/queries/package-by-id.graphql';

export default class PackageTasksService extends Service {
  @service session;
  @queryManager apollo;

  #tryToBuildStaffMemberContext(context, variables) {
    let updatedVariables = {
      ...variables,
    };
    const staffCategoryId = context?.categoryId;
    if (staffCategoryId) {
      updatedVariables.servicePriceContext = { staffCategoryId };
      updatedVariables.staffCategoryId = staffCategoryId;
    }

    const userId = context?.userId;
    if (userId) {
      updatedVariables.serviceDurationContext = { userId };
    }
    return updatedVariables;
  }

  @task
  *_executeRequestTask(variables) {
    return yield this.apollo.query(
      {
        query: packageByIdQuery,
        variables,
      },
      'serviceGroup'
    );
  }

  #buildPackageWithGroupOptionsInStaffContexts(packages) {
    return packages.reduce(
      (acc, curr, index) => {
        let { serviceGroupOptions, ...rest } = curr;
        let updatedServiceGroupOptions = acc.serviceGroupOptions;
        updatedServiceGroupOptions.push(serviceGroupOptions[index]);
        return {
          ...rest,
          serviceGroupOptions: updatedServiceGroupOptions,
        };
      },
      { serviceGroupOptions: [] }
    );
  }

  @task
  *fetchPackageTask(packageId, staffMemberContext) {
    const gqlVariables = {
      branchId: this.session.branchId,
      id: packageId,
    };
    if (Array.isArray(staffMemberContext)) {
      let promises = staffMemberContext.map((context) => {
        let variables = this.#tryToBuildStaffMemberContext(
          context,
          gqlVariables
        );

        return this._executeRequestTask.perform(variables);
      });
      let response = yield Promise.all(promises);
      return this.#buildPackageWithGroupOptionsInStaffContexts(response);
    } else {
      let variables = this.#tryToBuildStaffMemberContext(
        staffMemberContext,
        gqlVariables
      );

      return this._executeRequestTask.perform(variables);
    }
  }
}
